import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Col } from "react-bootstrap";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import { fetchLocationMaps } from "LocationMapActions";
import {
  fetchInteractiveMaps,
  updateInteractiveMap,
} from "InteractiveMapAction";
import NoContent, { NO_MAP } from "NoContent";
import { screenHeightLeftFromTop } from "Constants";
import LocationMapItem from "./location-map-item";
import AllMapItem from "./all-map-item-list";
import LocaleStrings from "Languages";
import Loader from "Loader";

class ALLMapList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.content_text_preparing_map,
      loader: false,
      activeLoader: false,
      pageLoader: false,
      pageNumber: 1,
      activeCount: 0,
    };
  }

  componentDidMount() {
    this.props.actions.fetchLocationMaps(this.props.session, (callback) => {
      this.props.actions.fetchInteractiveMaps(
        this.props.session,
        (callback) => {
          this.setState({ loading: false });
        }
      );
    });
    // setTimeout(() => {
    //   this.props.actions.fetchLocationMaps(this.props.session,(callback)=>{
    //       this.props.actions.fetchInteractiveMaps(this.props.session,(callback)=>{
    //     });
    //   });
    // }, 400);
  }

  renderLocationMapList() {
    var items = _.map(this.props.locationmaps, (locationmap, index) => {
      return (
        <Col
          sm={4}
          md={3}
          lg={3}
          key={locationmap.mapid}
          style={{ width: "auto" }}
        >
          <LocationMapItem locationmap={locationmap} is_locationmap={true} />
        </Col>
      );
    });
    return items;
  }

  renderInteractiveMapList() {
    var items = _.map(this.props.interactivemaps, (interactivemap, index) => {
      return (
        <Col
          sm={4}
          md={3}
          lg={3}
          key={interactivemap.interactivemapid}
          style={{ width: "auto" }}
        >
          <LocationMapItem
            locationmap={interactivemap}
            is_locationmap={false}
          />
        </Col>
      );
    });
    return items;
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    var arrAvailable = _.orderBy(
      _.concat(this.props.locationmaps, this.props.interactivemaps),
      ["displayorder", "createdon"],
      ["asc", "desc"]
    );

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

    var newArrAvailable = [];

    this.setState({ activeCount: arrAvailable.length });

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displayorder: index + 1 });
    });

    this.setState({ pageLoader: true });

    var interactivemapVar = _.filter(newArrAvailable, "interactivemapid");
    var locationmapVar = _.filter(newArrAvailable, "mapid");

    if (interactivemapVar.length > 0 && locationmapVar.length > 0) {
      // Update Map sequence
      this.props.actions.updateInteractiveMap(
        locationmapVar,
        this.props.session,
        false,
        (res) => {
          this.props.actions.updateInteractiveMap(
            interactivemapVar,
            this.props.session,
            true,
            (res) => {
              this.setState({ pageLoader: false });
            }
          );
        }
      );
    } else {
      // Update Map sequence
      if (locationmapVar.length > 0) {
        this.props.actions.updateInteractiveMap(
          locationmapVar,
          this.props.session,
          false,
          (res) => {
            this.setState({ pageLoader: false });
          }
        );
      }

      if (interactivemapVar.length > 0) {
        this.props.actions.updateInteractiveMap(
          interactivemapVar,
          this.props.session,
          true,
          (res) => {
            this.setState({ pageLoader: false });
          }
        );
      }
    }
  };

  render() {
    let { deviceSize, locationmaps, interactivemaps } = this.props;
    let { pageNumber, pageLoader } = this.state;
    let mapArr = [];
    let pageDataLength = 0;
    var showLocationMaps = this.props.locationmaps.length > 0;
    var showInteractiveMaps = this.props.interactivemaps.length > 0;
    var noMap = !showLocationMaps && !showInteractiveMaps;

    if (
      this.props.locationmaps.length > 0 ||
      this.props.interactivemaps.length > 0
    ) {
      mapArr = _.orderBy(
        _.concat(this.props.locationmaps, this.props.interactivemaps),
        ["displayorder", "createdon"],
        ["asc", "desc"]
      );

      pageDataLength =
        this.props.locationmaps.length + this.props.interactivemaps.length;
    }

    var classCustom = "";
    if (pageLoader) {
      classCustom = "gamification-page-loading";
    }

    const SortableSection = SortableElement(
      ({ value, pageDataLength, currentPage }) => (
        <div>
          <AllMapItem
            key={value.eventid}
            mapdata={value}
            pageDataLength={pageDataLength}
            currentPage={currentPage}
            style={{ zIndex: 10000 }}
          />
        </div>
      )
    );

    const SortableSectionList = SortableContainer(
      ({ collection, pageDataLength, currentPage, disabled }) => {
        return (
          <div>
            {collection.map((value, index) => {
              return (
                <SortableSection
                  key={`section-${index}`}
                  index={index}
                  value={value}
                  pageDataLength={pageDataLength}
                  currentPage={currentPage}
                  disabled={disabled}
                />
              );
            })}
          </div>
        );
      }
    );

    return (
      <div>
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : locationmaps.length > 0 || interactivemaps.length > 0 ? (
            <div>
              <div
                className="row mb-10"
                style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
              >
                <div className="col-md-4" style={{ paddingLeft: 68 }}>
                  {LocaleStrings.content_map_list_name}
                </div>
                <div className="col-md-4" style={{ paddingLeft: 40 }}>
                  {LocaleStrings.content_map_list_type}
                </div>
                <div className="col-md-4" style={{ paddingLeft: 40 }}>
                  {LocaleStrings.content_map_list_action}
                </div>
              </div>
              <div
                className={`col-md-12 ${classCustom}`}
                style={{
                  backgroundColor: "#ffffff",
                  backfaceVisibility: "hidden",
                  willChange: "transform",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  titleBarStyle: "hidden",
                }}
              >
                <SortableSectionList
                  useDragHandle
                  collection={mapArr}
                  onSortEnd={this.onSortEnd}
                  //pressDelay={100}
                  axis="y"
                  lockAxis="y"
                  pageDataLength={pageDataLength}
                  currentPage={pageNumber}
                />
              </div>
            </div>
          ) : (
            <NoContent contentType={NO_MAP} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    locationmaps: state.locationMaps,
    session: state.session,
    interactivemaps: state.interactiveMaps,
    deviceSize: state.deviceSize,
  };
}

var bindActionsToProps = (dispatch) => ({
  actions: bindActionCreators(
    { fetchLocationMaps, fetchInteractiveMaps, updateInteractiveMap },
    dispatch
  ),
});

export default connect(mapStateToProps, bindActionsToProps)(ALLMapList);
